// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"619f402b","421":"2b72abc7","463":"99a4f177","589":"d7d947a6","742":"48263d5b","898":"26858f25"}[chunkId] + ".chunk.js";
};